<template>
    <section class="bg-backgroundDark text-gold py-8 md:py-10 shadow-glow-gold">
        <div class="container mx-auto text-center px-6">
            <h1 class="text-3xl md:text-5xl font-bold mb-3 leading-tight">
                Votre niveau a sa place.
            </h1>
            <p class="text-base md:text-lg text-backgroundLight max-w-3xl mx-auto mb-6">
                Montez dans le classement, gagnez du statut et entrez dans l’orbite des profils qui comptent.
            </p>
            <div class="flex justify-center gap-4 flex-wrap">
                <router-link :to="primaryCta.to" class="btn-gold">
                    {{ primaryCta.label }}
                </router-link>
                <router-link :to="secondaryCta.to" class="btn-secondary">
                    {{ secondaryCta.label }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()

const primaryCta = computed(() => {
    if (authStore.isLoggedIn) {
        return {
            label: 'Monter au classement',
            to: { name: 'BuyRanking' }
        }
    }

    return {
        label: 'Rejoins le classement',
        to: { name: 'LoginRegister', query: { view: 'register' } }
    }
})

const secondaryCta = computed(() => {
    if (authStore.isLoggedIn) {
        return {
            label: 'Voir mon classement',
            to: { name: 'UserRanking' }
        }
    }

    return {
        label: 'Calculateur de richesse',
        to: { name: 'WealthCalculator' }
    }
})
</script>
